import { render, staticRenderFns } from "./CloudpaymentsStatusPage.vue?vue&type=template&id=b0cfb9d4&"
import script from "./CloudpaymentsStatusPage.vue?vue&type=script&lang=js&"
export * from "./CloudpaymentsStatusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports